import React from 'react'
import {useDispatch} from 'react-redux'

import {Button, Variant} from '@vio/atlas/Button'
import {trackLoginClick} from '@vio/core/src/auth/modules/actions'
import {
  AuthenticationFlows,
  ShowPasswordlessLoginPayload,
  SourceComponentType
} from '@vio/core/src/auth/types/Auth'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  onSignIn: ({
    sourceComponent,
    flow
  }: {
    sourceComponent: ShowPasswordlessLoginPayload['sourceComponent']
    flow: ShowPasswordlessLoginPayload['flow']
  }) => void
  /** Button variant */
  buttonVariant?: Variant
}

export const SignInButton = ({onSignIn, buttonVariant = 'ghost'}: Props) => {
  const dispatch = useDispatch()

  const component = SourceComponentType.Header

  const handleSingInClick = () => {
    dispatch(trackLoginClick(component))

    onSignIn({
      sourceComponent: component,
      flow: AuthenticationFlows.SignUp
    })
  }

  return (
    <Button
      variant={buttonVariant}
      isRounded={buttonVariant === 'tertiary'}
      size={'md'}
      dataId="SignInButton"
      onClick={handleSingInClick}
    >
      <FormattedMessageWrapper id="signInButton" defaultMessage="Sign in" />
    </Button>
  )
}
